import axios, { AxiosRequestConfig } from 'axios';
import { getAuthTokenHeader } from '../components/app/components/auth/auth';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: 'json',
});

type CustomRequestConfig = AxiosRequestConfig & {
  authorize?: boolean;
};

async function resolveAuthTokenHeader(
  headers?: any,
  config?: CustomRequestConfig,
) {
  // By default, send the authorization header always
  // Only case for not sending it if API consumer sends explicit
  // false on authorize property
  if (!config || config.authorize == null || config.authorize) {
    return {
      headers: {
        ...headers,
        ...(await getAuthTokenHeader()),
      },
    };
  }

  return { headers };
}

export default {
  async get<T>(url: string, data?: any, config?: CustomRequestConfig) {
    return axiosInstance.get<T>(url, {
      ...data,
      ...(await resolveAuthTokenHeader(data?.headers, config)),
    });
  },

  async post<T>(url: string, data?: any, config?: CustomRequestConfig) {
    return axiosInstance.post<T>(url, data, {
      ...config,
      ...(await resolveAuthTokenHeader(config?.headers, config)),
    });
  },

  async put<T>(url: string, data?: any, config?: CustomRequestConfig) {
    return axiosInstance.put<T>(url, data, {
      ...config,
      ...(await resolveAuthTokenHeader(config?.headers, config)),
    });
  },

  async delete<T>(url: string, config?: CustomRequestConfig) {
    return axiosInstance.delete<T>(url, {
      ...config,
      ...(await resolveAuthTokenHeader(config?.headers, config)),
    });
  },
};

export const API_URL = process.env.REACT_APP_API_URL;
